import { DropdownMenu as RadixMenu } from "radix-ui";
import type { ComponentProps, ReactNode } from "react";
import { cn } from "../../lib/utils";

/** Keyboard-accessible menu (arrow keys, Escape, typeahead) built on Radix. */
export const Menu = ({
  trigger,
  children,
  align = "end",
}: {
  trigger: ReactNode;
  children: ReactNode;
  align?: "start" | "end";
}) => (
  <RadixMenu.Root>
    <RadixMenu.Trigger asChild>{trigger}</RadixMenu.Trigger>
    <RadixMenu.Portal>
      <RadixMenu.Content
        align={align}
        sideOffset={6}
        className="z-50 min-w-56 rounded-md border border-border bg-surface p-1 shadow-lg focus:outline-none"
      >
        {children}
      </RadixMenu.Content>
    </RadixMenu.Portal>
  </RadixMenu.Root>
);

export const MenuItem = ({ className, ...props }: ComponentProps<typeof RadixMenu.Item>) => (
  <RadixMenu.Item
    className={cn(
      "flex cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none select-none data-[highlighted]:bg-surface-muted",
      className,
    )}
    {...props}
  />
);

export const MenuLabel = ({ children }: { children: ReactNode }) => (
  <RadixMenu.Label className="px-2 py-1.5 text-xs text-subtle">{children}</RadixMenu.Label>
);

export const MenuSeparator = () => <RadixMenu.Separator className="my-1 h-px bg-border" />;
